/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * OrganizerPlaceholder
 * --------------------
 * Stands in for the organizer rail's Events, Statistics and Settings screens
 * until each is built. Reachable and clearly labelled rather than a dead nav
 * item that looks broken — the designs for Events (live + results) and
 * Statistics exist and are queued behind Home.
 */

import React from 'react';
import '../../styles/organizer.css';

function OrganizerPlaceholder({ title, subtitle, body }) {
  return (
    <>
      <header className="org-topbar">
        <div>
          <h1>{title}</h1>
          {subtitle && <p className="org-sub">{subtitle}</p>}
        </div>
      </header>
      <div className="org-content">
        <div className="org-empty">
          <h2>Not built yet</h2>
          <p>{body}</p>
        </div>
      </div>
    </>
  );
}

export default OrganizerPlaceholder;
